import { render, staticRenderFns } from "./VehiclesListTable.vue?vue&type=template&id=468f99e8&"
import script from "./VehiclesListTable.vue?vue&type=script&lang=ts&"
export * from "./VehiclesListTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports